import {
    ROUTE_ACTIVE_WORKSPACES_DETAILS,
    // ROUTE_USERS_LIST,
    ROUTE_WORKSPACES_LIST,
    ROUTE_CONTACT_TYPE_LIST,
    ROUTE_ADDRESS_TYPE_LIST,
    ROUTE_COUNTRY_LIST,
    ROUTE_CONSENTS,
    ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
    ROUTE_ROUTES,
    ROUTE_DEVICES,
    ROUTE_DRIVERS,
    ROUTE_VEHICLES,
    ROUTE_TELEMETRY,
    ROUTE_ROUTE_REPORT,
    ROUTE_POI,
    ROUTE_SENT,
    ROUTE_STATISTICS,
    ROUTE_ECODRIVING,
    ROUTE_INVOICES,
    ROUTE_INVOICE,
    ROUTE_TARIFF_LIST,
    ROUTE_TARIFF_LOGS,
    ROUTE_PAYMENT_LOGS
} from "../config/routes";
import {
    faGlobeEurope,
    faUsers,
    faMobile,
    faBook,
    faAddressCard,
    faGlobe,
    faPager,
    faPassport,
    faLocationArrow,
    faIdCard,
    faTruckMoving,
    faTabletAlt,
    faRoad,
    faMapMarkerAlt,
    faFileImport,
    faMapMarkedAlt,
    faChartArea, faLeaf, faDollarSign, faFileInvoiceDollar, faArchive, faMoneyCheckAlt,
    faFileContract
} from '@fortawesome/free-solid-svg-icons'
export default async function getMenuData() {
    // property assigned means shows when workspace is assigned to superAdmin
    // property "both" means admin and user will get that menu to render
    // property "admin" means admin will get that menu to render
    // no extra property means user will get that menu to render
    return [
        {
            category: true,
            title: 'reports',
        },
        {
            title: 'sent_declarations',
            key: 'sent_declarations',
            icon: faFileContract,
            url: ROUTE_SENT,
        },
        {
            title: "reports_gps",
            key: 'reports_gps',
            icon: faLocationArrow,
            assigned: true,
            children: [
                {
                    title: "telemetry",
                    key: 'telemetry',
                    icon: faMapMarkerAlt,
                    url: ROUTE_TELEMETRY,
                },
                {
                    title: "roads",
                    key: 'roads',
                    icon: faRoad,
                    url: ROUTE_ROUTES,
                },
                {
                    title: "road_report",
                    key: "road_report",
                    icon: faFileImport,
                    url: ROUTE_ROUTE_REPORT
                },
            ]
        },
        {
            title: "statistics",
            key: "statistics",
            icon: faChartArea,
            url: ROUTE_STATISTICS
        },
        {
            title: "eco_driving",
            key: "ecodriving",
            icon: faLeaf,
            url: ROUTE_ECODRIVING
        },
        {
            category: true,
            title: 'manage_account'
        },
        {
            title: "gps_devices",
            key: 'gps_devices',
            icon: faTabletAlt,
            url: ROUTE_DEVICES,
            admin: true,
            hide: true
        },
        {
            title: "vehicles",
            key: "vehicles",
            icon: faTruckMoving,
            url: ROUTE_VEHICLES
        },
        {
            title: "drivers",
            key: "drivers",
            icon: faIdCard,
            url: ROUTE_DRIVERS
        },
        {
            title: "user_poi",
            key: 'user_poi',
            icon: faMapMarkedAlt,
            url: ROUTE_POI,
        },
        {
            title: 'company_profile',
            key: 'company_profile',
            icon: faGlobeEurope,
            url: ROUTE_ACTIVE_WORKSPACES_DETAILS
        },
        {
            title: "invoices",
            key: "invoices",
            icon: faDollarSign,
            url: ROUTE_INVOICE,
            subscriber: true
        },
        {
            category: true,
            title: 'dictionaries',
            admin: true,
        },
        {
            title: 'dictionaries',
            key: 'dictionaries',
            icon: faBook,
            admin: true,
            children: [
                {
                    title: 'contact_types',
                    key: 'contact_types',
                    icon: faMobile,
                    url: ROUTE_CONTACT_TYPE_LIST,
                    admin: true
                },
                {
                    title: 'address_types',
                    key: 'addressTypes',
                    icon: faAddressCard,
                    url: ROUTE_ADDRESS_TYPE_LIST,
                    admin: true
                },
                {
                    title: 'countries',
                    key: 'countries',
                    icon: faGlobe,
                    url: ROUTE_COUNTRY_LIST,
                    admin: true
                },
                {
                    title: 'consent_types',
                    key: 'consentTypes',
                    icon: faPager,
                    url: ROUTE_CONSENTS,
                    admin: true
                },
                {
                    title: 'employee_document_types',
                    key: 'employee_document_types',
                    icon: faPassport,
                    url: ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
                    admin: true
                },
            ]

        },
        {
            category: true,
            title: 'users_workspaces',
            admin: true
        },
        // {
        //     title: 'userslist',
        //     key: 'userslist',
        //     url: ROUTE_USERS_LIST,
        //     icon: faUsers,
        //     admin: true
        // },
        {
            title: 'client_list',
            key: 'client_list',
            url: ROUTE_WORKSPACES_LIST,
            icon: faUsers,
            admin: true
        },
        {
            title: "invoices_client",
            key: "invoice",
            icon: faDollarSign,
            url: ROUTE_INVOICES("all"),
            admin: true
        },
        {
            title: "tariff_list",
            key: "tariff_list",
            icon: faFileInvoiceDollar,
            url: ROUTE_TARIFF_LIST,
            admin: true
        },
        {
            title: "tariff_logs",
            key: "tariff_logs",
            icon: faArchive,
            url: ROUTE_TARIFF_LOGS,
            admin: true
        },
        {
            title: "payment_logs",
            key: "payment_logs",
            icon: faMoneyCheckAlt,
            url: ROUTE_PAYMENT_LOGS,
            admin: true
        },
    ]
}
